/**
 * Helpers compartidos para el análisis de empresas licitadoras.
 * Usados por RadarDolor (ranking) y EmpresaLicitadora (detalle).
 */

export function formatEUR(v) {
  const n = Number(v || 0);
  if (n >= 1_000_000_000) return `${(n / 1_000_000_000).toFixed(1)} B€`;
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)} M€`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(0)} K€`;
  return `${n.toFixed(0)} €`;
}

/**
 * Perfil comercial sugerido según tasa de derrota.
 *
 * La idea: no todas las empresas que aparecen en el Radar son "perdedores
 * seriales". Algunas son high performers que solo pierden un % pequeño —
 * el pitch comercial es distinto.
 *
 * Categorías:
 *   - serial_loser     (≥60% tasa derrota): dolor agudo
 *   - en_riesgo        (35-60%): balance inestable
 *   - high_performer   (<35%): ganador habitual con ventana de mejora
 */
export function perfilComercial(resumen) {
  if (!resumen) return null;
  const derrotas = resumen.total_derrotas || 0;
  const victorias = resumen.total_victorias || 0;
  const total = derrotas + victorias;
  if (total === 0) return null;
  const tasaDerrota = (derrotas / total) * 100;
  const tasaVictoria = 100 - tasaDerrota;

  if (tasaDerrota >= 60) {
    return {
      tipo: "serial_loser",
      etiqueta: "Serial Loser",
      color: "bg-red-500/15 text-red-700 dark:text-red-300 border-red-500/40",
      colorSolid: "text-red-700 dark:text-red-300",
      mensaje:
        "Patrón crítico de derrotas. Dolor agudo. Pitch directo: 'llevas X fracasos seguidos, aquí tienes por qué y cómo cortarlo'.",
      tasa_derrota: tasaDerrota,
      tasa_victoria: tasaVictoria,
    };
  }
  if (tasaDerrota >= 35) {
    return {
      tipo: "en_riesgo",
      etiqueta: "En Riesgo",
      color: "bg-orange-500/15 text-orange-700 dark:text-orange-300 border-orange-500/40",
      colorSolid: "text-orange-700 dark:text-orange-300",
      mensaje:
        "Balance 50/50. Pitch de mejora: 'con pequeños ajustes en los criterios donde fallas, ganas más'.",
      tasa_derrota: tasaDerrota,
      tasa_victoria: tasaVictoria,
    };
  }
  return {
    tipo: "high_performer",
    etiqueta: "High Performer",
    color: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-300 border-emerald-500/40",
    colorSolid: "text-emerald-700 dark:text-emerald-300",
    mensaje: `Ganas habitualmente (${tasaVictoria.toFixed(0)}% tasa de victoria). Pitch: 'lo bueno se puede hacer extraordinario — ayudo con el ${tasaDerrota.toFixed(0)}% que se te escapa'.`,
    tasa_derrota: tasaDerrota,
    tasa_victoria: tasaVictoria,
  };
}
